var _g, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 767,
    height: 417,
    viewBox: "0 0 767 417",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_702_1795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.827 -42.0114C307.827 -80.6633 339.187 -111.997 377.866 -111.997H485.251C523.93 -111.997 555.29 -80.6633 555.29 -42.0114V65.3003C555.29 103.953 528.302 99.1812 489.615 99.1812L310.897 174.002C180.757 218.85 166.264 255.863 307.827 65.3003V-42.0114Z",
    fill: "url(#paint0_linear_702_1795)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#filter1_f_702_1795)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M350.288 -20.8183C350.288 -38.9838 364.996 -53.7098 383.133 -53.7098H433.503C451.648 -53.7098 466.356 -38.9838 466.356 -20.8183V29.6155C466.356 47.781 453.7 45.5388 435.555 45.5388L332.855 99.0856C-171.832 432.457 283.886 119.175 350.288 29.6155V-20.8183Z",
    fill: "url(#paint1_linear_702_1795)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#filter2_f_702_1795)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M540.713 -152.528C540.713 -184.57 566.698 -210.545 598.747 -210.545H687.742C719.791 -210.545 745.776 -184.57 745.776 -152.528V-63.5685C745.776 -31.5265 723.412 -35.4816 691.356 -35.4816L509.912 58.9689C-381.725 646.999 423.397 94.4045 540.713 -63.5685V-152.528Z",
    fill: "url(#paint2_linear_702_1795)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#filter3_f_702_1795)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M553.453 -165.645C553.453 -190.443 573.558 -210.545 598.364 -210.545H667.216C692.022 -210.545 712.127 -190.443 712.127 -165.645V-96.7994C712.127 -72.002 694.816 -75.0628 670.018 -75.0628L529.619 -1.96729C-160.309 453.111 462.681 25.4562 553.453 -96.7994V-165.645Z",
    fill: "url(#paint3_linear_702_1795)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_702_1795",
    x: 0.864914,
    y: -318.499,
    width: 760.928,
    height: 735.088,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 103.251,
    result: "effect1_foregroundBlur_702_1795"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_702_1795",
    x: 56.7047,
    y: -95.0105,
    width: 450.952,
    height: 385.455,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.6503,
    result: "effect1_foregroundBlur_702_1795"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_702_1795",
    x: 74.3497,
    y: -231.195,
    width: 692.076,
    height: 575.501,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.3251,
    result: "effect1_foregroundBlur_702_1795"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_702_1795",
    x: 187.921,
    y: -231.195,
    width: 544.856,
    height: 454.72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.3251,
    result: "effect1_foregroundBlur_702_1795"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_702_1795",
    x1: 321.93,
    y1: -34.9646,
    x2: 463.087,
    y2: 106.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FFFD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFBF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_702_1795",
    x1: 432.646,
    y1: -67.4221,
    x2: 498.986,
    y2: -1.16584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFD63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_702_1795",
    x1: 552.396,
    y1: -146.686,
    x2: 669.413,
    y2: -29.6297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FFFD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461458,
    stopColor: "#FAF9B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFD63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_702_1795",
    x1: 562.495,
    y1: -161.124,
    x2: 653.052,
    y2: -70.5489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FFFD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461458,
    stopColor: "#FAF9B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFD63"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.b025e375dcc3672e504427f07fca3916.svg";
export { ForwardRef as ReactComponent };